export default __webpack_public_path__ + "static/media/smart-scale.8f754652.svg";